import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useThemeModel } from '@entities/theme'

export default /*#__PURE__*/_defineComponent({
  __name: 'QuizButton',
  emits: ['onClick'],
  setup(__props, { emit: emits }) {


const themeModel = useThemeModel()

const logoImage = computed(() =>
  themeModel.theme.toLowerCase() === 'novikov' ? require('./../../assets/logo-red.svg') : require('./../../assets/logo.svg')
)

return { __sfc: true,emits, themeModel, logoImage }
}

})